import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormArray, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { getStorage } from 'src/app/utils/helper/storage';
import { ACTIVE } from 'src/app/utils/items/active';
import { series } from 'src/app/utils/items/series';
import { CURRENT_USER } from 'src/app/utils/items/storage-names';
import { MedicalHistoryService } from 'src/app/utils/services/mpi/medical-history.service';

@Component({
  selector: 'app-immunization-history',
  templateUrl: './immunization-history.component.html',
  styleUrls: ['./immunization-history.component.scss']
})
export class ImmunizationHistoryComponent implements OnInit {

  @Input()
  patientID: any;

  editMode = false;
  processing = true;
  items: any;
  form: FormGroup;
  series = [];
  user: any;

  toDelete = [];

  constructor(
    private service: MedicalHistoryService,
    private toastr: ToastrService,
    private fb: FormBuilder
  ) { }

  ngOnInit(): void {
    this.user = getStorage(CURRENT_USER, true)?.doctor?.primary_name?.full
    this.series = series;
    this.createForm();
    this.list();
  }

  createForm() {
    this.form = this.fb.group({
      immunizations: this.fb.array([])
    });
  }

  add() {
    this.immunizations.push(this.create());
  }

  remove(index) {
    if (this.immunizations.at(index)?.value?.id) {
      this.toDelete.push(this.immunizations.at(index)?.value?.id);
    }
    this.immunizations.removeAt(index);
  }

  create(item = null) {
    return this.fb.group({
      id: item?.id,
      clinical_status_uid: [item?.clinical_status_uid ?? ACTIVE],
      vaccine: [item?.vaccine, Validators.required],
      brand_name: [item?.brand_name],
      series: [item?.series],
      dose_ml: [item?.dose_ml],
      site_given: [item?.site_given],
      route: [item?.route],
      lot_no: [item?.lot_no],
      administered_by: [item?.administered_by],
      administered_on: [item?.administered_on, Validators.required],
      administered_facility: [item?.administered_facility],
      next_dose_on: [item?.next_dose_on],
      notes: [item?.notes]
    });
  }

  get immunizations() {
    return this.form.get('immunizations') as FormArray;
  }

  transform() {
    this.immunizations.clear();

    if (this.items?.data?.length < 1) {
      this.immunizations.push(this.create());
    } else {
      this.items?.data?.forEach((item) => {
        this.immunizations.push(this.create(item));
      });
    }
  }

  list() {
    this.service.getImmunization({
      patient_id: this.patientID,
      order: 'vaccine_administered_on',
    })
      .subscribe((response: any) => {
        this.items = response;
        this.processing = false;
        this.transform();
      }, (err) => {
        this.processing = false;
      })
  }

  save() {
    this.processing = true;
    this.service.saveImmunization(this.patientID, {
      immunizations: this.form.value?.immunizations?.map((item) => {
        if (item?.administered_by === null || item?.administered_by?.trim() === '') {
          item.administered_by = this.user
        }

        return item;
      }).filter((item) => item?.vaccine && item?.vaccine && item?.administered_on),
      to_delete: this.toDelete
    })
      .subscribe((response: any) => {
        this.editMode = false;
        this.toDelete = [];

        this.items.data = response;
        this.transform();

        this.processing = false;
        this.toastr.success("Successfully updated the immunization history");
      }, (err) => {
        this.processing = false;
      });
  }

  cancel() {
    this.editMode = false
    this.toDelete = [];
    this.transform();
  }
}
